<template>
  <footer class="py-4 bg-[#00007b] text-white">
    <div class="container mx-auto flex flex-col items-center text-sm">
      <div>(+54) 9 11 6252-8230</div>
      <div>admin@expoindustrias.com.ar</div>
      <div class="text-xs my-2">© 2026 QREventos.com</div>
    </div>
  </footer>
</template>


<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>